import { render, staticRenderFns } from "./section-trend-chart-template1.vue?vue&type=template&id=72a0982c&scoped=true"
import script from "./section-trend-chart-template1.vue?vue&type=script&lang=js"
export * from "./section-trend-chart-template1.vue?vue&type=script&lang=js"
import style0 from "./section-trend-chart-template1.vue?vue&type=style&index=0&id=72a0982c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0982c",
  null
  
)

export default component.exports